module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_9006.51c84b79.png";